import { useRouter } from "next/router";
function useCheckDashboardContainer() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  if (pathname.includes("/dashboard")) {
    return true;
  }
  return false;
}
export default useCheckDashboardContainer;